var classes = {"promoBanner":"zHJqC","promoBannerSlide":"_2gfyC"};

export { classes as default };
